module.exports = "/fonts/materialdesignicons-webfont.eot?a1a0ed860f50ffd42ba46d7c10f30255";